/** Prüfpflicht Schritt 1: Popup bei Lücken in der Anzeige. */
const wizJobGateDE = {
  wizGateTitle: 'Die Anzeige hat noch Lücken',
  wizGateIntro:
    'Bei {{count}} Punkten fehlen Angaben. Ergänze die Anzeige, dann findet SAIA passendere Kandidaten und schreibt genauere Nachrichten.',
  wizGateIntroOne:
    'Bei einem Punkt fehlen Angaben. Ergänze die Anzeige, dann findet SAIA passendere Kandidaten und schreibt genauere Nachrichten.',
  wizGatePlaceholders:
    'In deinen Ergänzungen stehen noch Platzhalter in eckigen Klammern, z. B. „[Spanne eintragen]“. Ersetze sie durch echte Angaben oder lösche sie – sonst gehen sie ungeprüft in die Kampagne.',
  wizGateHint:
    'Du musst nicht alles ergänzen: Mit „Überspringen“ geht es sofort weiter, die Anzeige kannst du später noch anpassen.',
  wizGateAmend: 'Anzeige ergänzen',
  wizGateProceed: 'Überspringen, ohne weitere Optimierung',
  wizGateCheckRequired: 'Bitte prüfe zuerst die Anzeige.',
  wizGateLocationRequired: 'Bitte gib zuerst an, wo die Stelle ist (oder dass sie zu 100 % remote ist).',
  wizLocationTitle: 'Wo ist die Stelle?',
  wizLocationHint:
    'Pflichtangabe: Ohne Ort findet die Suche keine passenden Kandidaten. Ist die Stelle voll remote, sag das hier.',
  wizLocationPlaceholder: 'z. B. Köln',
  wizLocationSubmit: 'Übernehmen',
  wizLocationRemote: 'Die Stelle ist 100 % remote',
  wizGateRetry: 'Erneut versuchen',
  wizGateSkip: 'Trotzdem weiter ohne Prüfung',
  wizGateCheckFailedMany:
    'Die Prüfung war mehrfach nicht erreichbar. Du kannst es erneut versuchen oder ohne Prüfung weitermachen.',
  wizGateCheckFailed: 'Die Prüfung ist fehlgeschlagen – bitte erneut versuchen.',
};
export default wizJobGateDE;
